var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("base-snackbar", {
        attrs: { errors: _vm.stockPutErrors },
        on: {
          "update:errors": function($event) {
            _vm.stockPutErrors = $event
          }
        }
      }),
      _c("stock-form", {
        attrs: {
          "input-fields": _vm.stockFields,
          "default-field-values": _vm.stockData,
          "error-messages": _vm.stockPutErrors
        },
        on: {
          "update:inputFields": function($event) {
            _vm.stockFields = $event
          },
          "update:input-fields": function($event) {
            _vm.stockFields = $event
          }
        }
      }),
      _c(
        "v-container",
        [
          _c(
            "v-btn",
            {
              attrs: {
                color: "primary",
                dark: "",
                small: "",
                loading: _vm.stockPutting
              },
              on: { click: _vm.update }
            },
            [_c("span", [_vm._v("Update")])]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }